import React, { useState } from "react";
import '../MobileCategoryHeader/MobileCategoryHeader.css';
import MobileCategoryFilterPopup from "./MobileCategoryFilterPopup/MobileCategoryFilterPopup";
import { FaFilter, FaSearch } from "react-icons/fa";

const MobileCategoryHeader = ({
  search,
  setSearch,
  columnSearch,
  setColumnSearch,
  onRefresh,
}) => {
  const [showOverlay, setShowOverlay] = useState(false);
  const [showFilterPopup, setShowFilterPopup] = useState(false);

  const handleRefresh = () => {
    setSearch("");
    setColumnSearch({
      status: "active",
      customerName: "",
      mobile: "",
      coins: "",
      createdBy: "",
      companyName: "",
      lastLoginStartDate: null,
      lastLoginEndDate: null,
      lastTransactionStartDate: null,
      lastTransactionEndDate: null,
      lastLogin: "",
      lastTransaction: "",
      reference: "",
      address: "",
      mapLocation: "",
    });
    if (onRefresh) onRefresh();
  };

  return (
    <>
     
      <div
        className={`mobile-customer-header-wrapper ${
          showFilterPopup ? "blur-background" : ""
        }`}
      >
        <div className="mobile-header fixed-header">
          <div className="mobile-search-container">
            <FaSearch className="mobile-search-icon" />
            <input
              type="text"
              placeholder="Search here..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="mobile-search-input"
            />
          </div>

         
          <FaFilter
            className="mobile-filter-icon"
            onClick={() => setShowFilterPopup(true)}
          />
        </div>
      </div>

    
      {showFilterPopup && (
        <MobileCategoryFilterPopup
          onClose={() => setShowFilterPopup(false)}
          columnSearch={columnSearch}
          setColumnSearch={setColumnSearch}
          handleRefresh={handleRefresh}
          onAdd={() => setShowOverlay(true)}
        />
      )}
    </>
  );
};

export default MobileCategoryHeader;
